import React from 'react';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { useCountdown } from '../../hooks/useCountdown';
import { useViewports } from '../../hooks/useViewports';
import responsiveTheme from '../../theme';
import { CountdownMessage } from './CountdownMessage';
import { SessionExtendedMessage } from './SessionExtendedMessage';
const LogoutCountdown = ({ platform, flags }) => {
    const { countdown, isSessionCountdownMsgOpened, isSessionExtendedMsgOpened, isSessionExtendable, handleSessionExtendClick, handleSessionCountdownMsgClose, handleSessionExtendedMsgClose, } = useCountdown({ platform, flags });
    const theme = useTheme();
    const { isDesktop } = useViewports(theme);
    const handleCountdownClose = (_, reason) => {
        if (reason === 'clickaway')
            return;
        handleSessionCountdownMsgClose();
    };
    const anchorOrigin = isDesktop
        ? { vertical: 'top', horizontal: 'right' }
        : { vertical: 'bottom', horizontal: 'center' };
    return (React.createElement(ThemeProvider, { theme: responsiveTheme },
        React.createElement(CountdownMessage, { open: isSessionCountdownMsgOpened, anchorOrigin: anchorOrigin, countdown: countdown, onClose: handleCountdownClose, refreshable: isSessionExtendable, onRefresh: handleSessionExtendClick }),
        React.createElement(SessionExtendedMessage, { open: isSessionExtendedMsgOpened, onClose: handleSessionExtendedMsgClose, anchorOrigin: anchorOrigin })));
};
export default LogoutCountdown;
//# sourceMappingURL=index.js.map